import { BasicAppliedFilters } from 'app/components/design-system-components/list-filters/BasicAppliedFilters'
import { buildRenderedFilterConfig } from 'app/features/teams/key-logger/KeysListFilters/filters.config'

export const KeysAppliedFilters = ({ filters, onDismissFilter }) => {
  return (
    <BasicAppliedFilters
      filtersConfig={buildRenderedFilterConfig(filters)}
      onDismissFilter={onDismissFilter}
    />
  )
}
